import { isLoggedIn } from "../utils/localStorage";
import LoginView from "../pages/Auth/views/Login.view";

const AuthWrapper = ({ children }) => {
  return isLoggedIn() ? <div>{children}</div> : <LoginView />;
};

export default AuthWrapper;
